export const SALESFORCE_ON_RESPONSE_EVENT = 'mcis:onEventResponse';
